import gql from "graphql-tag";

export const DELETE_MAIL_SETS = gql`
	mutation DeleteMailSet($mailSetId: UUID!) {
		deleteMailSet(input: { mailSetId: $mailSetId }) {
			success
			errors
		}
	}
`;
